import '../../utils/fix.cross-origin'
import DocumentLoginDialog from './document-login-dialog'

class DocumentLoginService {

	authKey = 'Authorization';

	Vue;

	constructor(Vue) {
		this.Vue = Vue
	}

	get $lv() {
		return this.Vue.prototype.$lv
	}

	get $http() {
		return this.Vue.prototype.$http
	}

	#dialog;

	get dialog() {
		if (!this.#dialog) {
			this.#dialog = this.$lv.newInstance(DocumentLoginDialog)
		}
		return this.#dialog
	}

	/**
	 * 获取public key
	 * @author weishengjian
	 * @date 2018/11/26
	 */
	async getPublicKey() {
		const url = 'action/base/user/publicKey'
		const {publicKey} = await this.$http.post(url)
		return publicKey;
	}

	async getJSEncrypt() {
		return await this.$lv.resource.loadLib('JSEncrypt')
	}

	/**
	 * 登录逻辑
	 * @author weishengjian
	 * @date 2018/11/26
	 */
	async login(loginUrl, username, password, onSuccess, onError, option) {
		if (!option) {
			this.captcha(loginUrl, username, password, onSuccess, onError);
			return ;
			// option = {}
		}
		try {
			const publicKey = await this.getPublicKey()
			const encrypt = new (await this.getJSEncrypt())();
			encrypt.setPublicKey(publicKey);
			const pass = encrypt.encrypt(password);
			const {respDTO: {data, error}} = await this.$http.post(loginUrl, {username, password: pass, ...option}, true);
			if (!error) {
				const {token, user, expires} = data
				const username = user.username;

				if (user.corpid !== '102' && user.corpid !== 102) {
					!!onError && onError('请使用注册工号登录')
					return;
				}
				window.CURRENT_ORIGIN_TOP.appCtx.username = username
				window.localStorage.setItem(`CRM_Username`, username); // 用户名
				window.localStorage.setItem(`CRM_Fstname`, user.firstName); // 用户名称
				window.localStorage.setItem(`CRM_${username}_${this.authKey}`, 'bearer ' + token); // token
				window.localStorage.setItem(`CRM_${username}_Expires`, expires); // 过期事件
				window.localStorage.setItem(`CRM_${username}_ExpiresTimestamp`, parseInt(expires) + Date.now()); // 过期时间戳
			}
			!!error ? !!onError && onError(error) : !!onSuccess && onSuccess(data)
		} catch (e) {
			console.error(e)
			!!onError && onError(e)
		}
	}

	logout() {
		const request = new XMLHttpRequest();
		const url = appCtx.ctxPath + '/action/link/token/remove';
		request.open('POST', url);// 同步请求
		request.setRequestHeader('Authorization', this.getToken());
		request.send();

		const username = window.localStorage.getItem('CRM' + '_Username')

		window.localStorage.removeItem(`CRM_${username}_${this.authKey}`); // 清除token
		window.localStorage.removeItem(`CRM_${username}_Expires`); // 清除有效时长
		window.localStorage.removeItem("LinkUI")
	}

	getUserName() {
		return window.localStorage.getItem('CRM_Username');
	}

	getToken() {
		return window.localStorage.getItem(`CRM_${this.getUserName()}_${this.authKey}`);
	}

	getFstName() {
		return window.localStorage.getItem('CRM_Fstname');
	}

	openLoginDialog(...args) {
		this.dialog.login(...args)
	}

	async captcha(loginUrl, username, password, onSuccess, onError) {
		// 固定取102账套配置
		const captchaConfig = await this.$http.get('/action/base/user/getCaptchaConfig?username=8527&v=' + Date.now()).catch(e => console.error('获取验证码配置错误：' + e));

		if (captchaConfig.success) {
			// 白名单
			let whiteList = [];
			if (captchaConfig.whiteList) {
				whiteList = captchaConfig.whiteList.split(',').map(username => username.toLowerCase());
			}
			if (captchaConfig.pcCheckFlag === 'Y' && captchaConfig.appId && whiteList.indexOf(username.toLowerCase()) === -1) {
				//唤醒验证码弹窗
				const captcha1 = new TencentCaptcha(captchaConfig.appId, (res) => {
					if (res.ticket && res.ticket !== '') {
						this.login(loginUrl, username, password, onSuccess, onError, {
							ticket: res.ticket,
							randStr: res.randStr,
							corpId: captchaConfig.corpId
						});
					} else {
						console.error('验证码校验不通过');
					}
				});
				captcha1.show();
			} else {
				this.login(loginUrl, username, password, onSuccess, onError, {})
			}
		}
	}
}

export {DocumentLoginService}
